import type { Middleware } from "@reduxjs/toolkit";
import { captureMessage } from "@sentry/react";
import {
  // eslint-disable-next-line no-restricted-imports
  toast,
} from "react-hot-toast";

import { dismissToast, removeToast, toastCustom, toastError, toastLoading, toastSuccess } from "./toastsReducers";

export const toastsMiddleware: Middleware = () => (next) => (action) => {
  if (toastSuccess.match(action)) {
    const { message, options } = action.payload;
    toast.success(message, options);
  } else if (toastError.match(action)) {
    const { message, options } = action.payload;
    if (message?.toString()) captureMessage(message.toString(), "error");
    toast.error(message, options);
  } else if (toastLoading.match(action)) {
    const { message, options } = action.payload;
    toast.loading(message, options);
  } else if (toastCustom.match(action)) {
    const { message, options } = action.payload;
    toast.custom(message, options);
  } else if (dismissToast.match(action)) {
    toast.dismiss(action.payload);
  } else if (removeToast.match(action)) {
    toast.remove(action.payload);
  }

  return next(action);
};
